import { AnyAction } from 'redux';
import { ClergyCompReportActions, ClergyCompReportState, CurrentContext, MapContext, ReportContext } from './models';

const InitialState: ClergyCompReportState = {
	currentContext: CurrentContext.LANDING,
	selectedDio: '',
	selectedRegion: '',
	dioHovered: '',
	mapContext: MapContext.LANDING,
	reportContext: null,
	filter: { dio: null, region: null },
	ports: {},
};

export const clergyCompReportReducer = (state = InitialState, action: AnyAction): ClergyCompReportState => {

	switch (action.type) {
		case ClergyCompReportActions.SET_CLERGY_REPORT_CONTEXT:
			return { ...state, currentContext: action.payload };

		case ClergyCompReportActions.SET_SELECTED_DIO:
			return { ...state, selectedDio: action.payload };

		case ClergyCompReportActions.SET_SELECTED_REGION:
			return { ...state, selectedRegion: action.payload };

		case ClergyCompReportActions.SET_MAP_CONTEXT:
			return { ...state, mapContext: action.payload };

		case ClergyCompReportActions.SET_DIO_HOVER:
			return { ...state, dioHovered: action.payload };
		case ClergyCompReportActions.SET_PORT:
			return {
				...state, ports: { ...state.ports, [action.payload.id]: action.payload.port },
			};
		case ClergyCompReportActions.SET_REPORT_CONTEXT:
			return {
				...state, reportContext: action.payload,
			};
		case ClergyCompReportActions.SET_MAP_FILTER:
			return {
				...state, filter: action.payload,
			};

		default: return state;
	}
};


export const setCurrentContext = (context: CurrentContext) => {
	return {
		type: ClergyCompReportActions.SET_CLERGY_REPORT_CONTEXT,
		payload: context,
	};
};

export const setSelectedDio = (dio: string) => {
	return {
		type: ClergyCompReportActions.SET_SELECTED_DIO,
		payload: dio,
	};
};

export const setSelectedRegion = (region: string) => {
	return {
		type: ClergyCompReportActions.SET_SELECTED_REGION,
		payload: region,
	};
};

export const setMapContext = (context: MapContext) => {
	return {
		type: ClergyCompReportActions.SET_MAP_CONTEXT,
		payload: context,
	};
};


export const setDioHovered = (dio: string) => {
	return {
		type: ClergyCompReportActions.SET_DIO_HOVER,
		payload: dio,
	};
};

export const setPort = (id: string, port: any) => {
	return {
		type: ClergyCompReportActions.SET_PORT,
		payload: { id, port },
	};
};


export const setReportContext = (context: ReportContext) => {
	return {
		type: ClergyCompReportActions.SET_REPORT_CONTEXT,
		payload: context,
	};
};


export const setMapFilter = (filter: any) => {
	return {
		type: ClergyCompReportActions.SET_MAP_FILTER,
		payload: filter,
	};
};
